import React, { FC, useEffect, useState } from 'react';
import Cookies from 'browser-cookies';

import css from './style.module.scss';

import List from '@sv-support-sdk/ui-components/src/components/Lists/List';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';
import Paragraph from '@sv-support-sdk/ui-components/src/components/Typography/Paragraph';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import ArticleBlockFooter from '../../Layout/ArticleBlock/ArticleBlockFooter';
import Rating from '../../Feedback/Rating';
import MessagePlaceholder from '../../Content/Message/MessagePlaceholder';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { rateFeedback } from '../../../store/actions/helpCenter';
import { selectUserId } from '../../../store/selectors/user';
import { WORKSPACE_STORAGE_NAME } from '../../../constants/workspace';
import { SUPPORT_CES_TOPICS } from '../../../constants/customerEffort';
import { $l } from '../../../locales';

interface IProps {
  slug: string;
}

const CustomerEffortBlock: FC<IProps> = ({ slug }) => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(selectUserId);
  const [selectedRate, setSelectedRate] = useState<number | null>(null);

  useEffect(() => {
    const score = Cookies.get(`${SUPPORT_CES_TOPICS}-${slug}`);

    if (score) {
      setSelectedRate(+score);
    }
  }, [slug]);

  const sendTopicCes = (score: number) => {
    const workspaceId = sessionStorage.getItem(WORKSPACE_STORAGE_NAME);

    dispatch(rateFeedback({
      slug,
      data: {
        score,
        organization_id: workspaceId || undefined,
        uid: userId,
      },
    }));

    setSelectedRate(score);
  };

  return (
    <ArticleBlockFooter>
      <MessagePlaceholder indents="24-16">
        {selectedRate ? (
          <List gap="4" align="center">
            <List gap="8" align="center">
              <div className={css.customerEffort__placeholderIcon}>
                <Icon id="colored--40--green-check" />
              </div>
              <div className={css.customerEffort__title}>
                {$l('CUSTOMER_EFFORT.THANK_YOU')}
              </div>
            </List>
            <Paragraph fontSize="12" align="center">
              {$l('CUSTOMER_EFFORT.WE_APPRECIATE')}
            </Paragraph>
          </List>
          ) : (
            <List gap="16" align="center">
              <Headline align="center" type="secondary" fontSize="20" lineHeight="32">
                {$l('CUSTOMER_EFFORT.HELP_CENTER_QUESTION')}
              </Headline>
              <Rating size="lg" selectRate={sendTopicCes} />
            </List>
          )
        }
      </MessagePlaceholder>
    </ArticleBlockFooter>
  );
};

export default CustomerEffortBlock;
